import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import '../App.css'; // Importando o arquivo CSS
import logoUltra from './logoUtra.jpeg';
function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    // try {
      // const response = await fetch('https://fsys.app.br/5dx/login.php', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({
      //     usuario: username,
      //     senha: password,
      //   }),
      //   mode: 'cors', // Adiciona suporte ao CORS
      // });

      // const data = await response.json();

      // if (data.success) {
        sessionStorage.setItem('matricula', JSON.stringify({  username }));
            navigate('/amigofarma');
    
      // sessionStorage.setItem('user', JSON.stringify({ username, id_empresa: data.id_empresa }));
    //   } else {
    //     alert(data.error || 'Erro ao realizar login');
    //   }
    // } catch (error) {
    //   sessionStorage.setItem('user', JSON.stringify({ username, id_empresa: '23' }));
    //    // navigate('/dashboard');
    //   alert('Erro de conexão. Tente novamente.');
    // } finally {
    //   setLoading(false);
    // }
  };

  return (
    <div className="container mt-5 login">
     <div style={{margin: 'auto', width: 150, marginBottom: 20}}>  <img src={logoUltra} alt="Logo Ultra" className="img-fluid" /></div>
      <Form onSubmit={handleLogin}>
        <Form.Group controlId="formBasicUsername">
          <Form.Label>Matricula</Form.Label>
          <Form.Control
            type="text"
            placeholder="Digite sua matricula"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </Form.Group>

        {/* <Form.Group controlId="formBasicPassword" className="mt-3">
          <Form.Label>Senha</Form.Label>
          <Form.Control
            type="password"
            placeholder="Digite sua senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </Form.Group> */}

        <Button variant="primary" type="submit" className="mt-3" disabled={loading}>
          {loading ? 'Entrando...' : 'Entrar'}
        </Button>
      </Form>
    </div>
  );
}

export default Login;
